import {
  Box,
  CircularProgress,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { AuthContext } from "context";
import 'dayjs/locale/it';
import { createMRTColumnHelper } from "material-react-table";
import toast from 'react-hot-toast';
import MDButton from "../../components/MDButton";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericTable from "../genericTable";


const GarbageFourthCopyManagment = () => {
  const navigate = useNavigate();
  const authContext = React.useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  const columnHelper = createMRTColumnHelper();

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'garbage-fourth-copy-managment-toast'});
    } else {
      toast.error(msg, {id: 'garbage-fourth-copy-managment-toast'});
    }
  };

  useEffect(() => {
      fetchDocument();
  }, []);

  const fetchDocument = async (docId) => {
    setLoading(true);
     apiService.get("/garbage-fourth-copy/",{area_id: localStorage.getItem("areaSelected")} ,{} )
      .then((response) => {
        if (response)
          setDocuments(response)
      })
      .catch((error) => {
        handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onEdit = (id) => {
    window.location.href = "/garbage-fourth-copy-managment/edit/" + id + "/";
  };

  const columns = [
    columnHelper.accessor('date', {
      header: 'Data',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('url', {
      header: 'Documento',
      size: 100,
      enableSorting: false,
      enableColumnFilterModes: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => (
        <MDButton
          onClick={() => window.open(cell.getValue(), '_blank')}
          size="small"
        > Vedi Documento </MDButton>
      )
    }),
    columnHelper.accessor('supplier', {
      header: 'Fornitore',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('confirmed_cer_code', {
      header: 'CER',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('disposal_plant', {
      header: 'Impianto smaltimento',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('wastes', {
      header: 'Rifiuti',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
      Cell: ({ cell }) => {
        const wastes = cell.getValue();

        return (
          <Box>
            {wastes.map((waste, index) => (
              <Typography key={index} variant="body2">
                {waste.material}: {waste.quantity}
              </Typography>
            ))}
          </Box>
        );
      }
    })
  ]

  async function deleteResource(id) {
          try {
            // Costruisci l'endpoint usando l'id fornito
            const endpoint = `/garbage-fourth-copy/`;

            // Parametri opzionali per la richiesta DELETE
            const params = {id:id}; // Puoi aggiungere parametri se necessario
            const headers = {}; // Headers opzionali

            // Esegui la chiamata DELETE
            const response = await apiService.delete(endpoint, params, headers);

            // Se arriviamo qui, la chiamata è andata a buon fine
            console.log(`Risorsa con id ${id} eliminata con successo:`, response);

            // Puoi fare qualcosa con la risposta, se necessario
            return response;

          } catch (error) {
            // Gestisci eventuali errori
            console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

            // Puoi gestire l'errore in modo specifico, ad esempio:
            if (error.message.includes('404')) {
              console.log(`La risorsa con id ${id} non è stata trovata`);
            } else if (error.message.includes('403')) {
              console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
            }

            // Rilancia l'errore se vuoi che venga gestito a un livello superiore
            throw error;
          }
        }

      function handleDelete(id) {
          if(window.confirm("Sei sicuro di voler eliminare questo documento?\n Attenzione questa operazione è irreversibile.")) {
          deleteResource(id)
              .then(result => {
                  handleSetNotification("documento eliminato con successo","success")
                  fetchDocument()
              })
              .catch(error => {
                  // Gestisci l'errore se non è stato gestito nella funzione
                  handleSetNotification("Si è verificato un errore durante l'eliminazione del documento. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032","error")
              });
          }
      }

  return (
    <DashboardLayout>
      <DashboardNavbar />
        {!loading ?
          <>
            <center>
              <Typography variant="h4" sx={{ marginTop: "20px" }}>Elenco quarte copie</Typography>
              {authContext.hasAuth("UPDATE_GARBAGEFOURTHCOPY") && <MDButton
                onClick={() => navigate("/garbage-fourth-copy-managment/add/")}
                size="large" sx={{ marginTop: "20px", marginBottom: "20px" }}> AGGIUNGI</MDButton>}
              <GenericTable
                data={documents}
                columns={columns}
                onEdit = {onEdit}
                onDelete = {handleDelete}
                authModelName="GARBAGEFOURTHCOPY"

              />
            </center>
          </>
          :
          <center>
            <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/>
          </center>
        }
    </DashboardLayout>

  );
};

export default GarbageFourthCopyManagment;